<template>
  <header class="header">
    <nav class="header__nav">
      <article class="header__nav__article_left">
        <aside class="header__nav__article_left__aside">
          <div class="header__nav__article_left__aside__div">
            <p class="header__nav__article_left__aside__div__p">
              Jonathan <br />
              Despeyroux
            </p>
          </div>
        </aside>
      </article>
      <!--  -->
      <article class="header__nav__article_right">
        <aside class="header__nav__article_right__aside_accueil">
          <div class="header__nav__article_right__aside_accueil__div">
            <router-link to="/" class="header__nav__article_right__aside_accueil__div__router-link">ACCUEIL
            </router-link>
          </div>
        </aside>
        <aside class="header__nav__article_right__aside_services">
          <div class="header__nav__article_right__aside_services__div">
            <router-link to="/services" class="header__nav__article_right__aside_services__div__router-link">SERVICES
            </router-link>
          </div>
        </aside>
        <aside class="header__nav__article_right__aside_apropos">
          <div class="header__nav__article_right__aside_apropos__div">
            <router-link to="/apropos" class="header__nav__article_right__aside_apropos__div__router-link">À PROPOS
            </router-link>
          </div>
        </aside>
        <aside class="header__nav__article_right__aside_contact">
          <div class="header__nav__article_right__aside_contact__div">
            <router-link to="/contact" class="header__nav__article_right__aside_contact__div__router-link">CONTACT
            </router-link>
          </div>
        </aside>
      </article>
    </nav>
    <section class="section">
      <article class="section__article_bleu"></article>
      <article class="section__article_blanc"></article>
      <article class="section__article_rouge"></article>
    </section>
  </header>
</template>

<script >
export default {
  name: 'NavbarDesktop',
}
</script>

<style  lang=scss>
router-link {
  display: block;
}
@import "@/style/color.scss";

.header {
  background-color: white;

  &__nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &__article_left {
      margin-left: 1rem;
      margin-top: 0.5rem;

      &__aside__div__p {
        font-size: 1.5rem;
      }
    }

    &__article_right {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      margin-top: auto;
      margin-bottom: auto;
      margin-right: 2vw;
      color: black;

      &__aside_accueil__div {
        margin-right: 1vw;

        &__router-link {
          color: black;
          font-size: 1.2rem;
        }

        &__router-link:hover {
          font-size: 1.2rem;
          color: $RV;
        }
      }

      &__aside_services__div {
        margin-right: 1vw;

        &__router-link {
          color: black;
          font-size: 1.2rem;
        }

        &__router-link:hover {
          font-size: 1.2rem;
          color: $RV;
        }
      }

      &__aside_apropos__div {
        margin-right: 1vw;

        &__router-link {
          color: black;
          font-size: 1.2rem;
        }

        &__router-link:hover {
          font-size: 1.2rem;
          color: $RV;
        }
      }

      &__aside_contact__div {

        &__router-link {
          color: black;
          font-size: 1.2rem;
        }

        &__router-link:hover {
          font-size: 1.2rem;
          color: $RV;
        }
      }
    }
  }
}

.section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 3px;

  &__article_bleu {
    background-color: #03224c;
    width: 100%;
  }

  &__article_blanc {
    background-color: white;
    width: 100%;
  }

  &__article_rouge {
    background-color: $RV;
    width: 100%;
  }
}
</style>